var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28718 18.8329V11.4712H5.83301V8.40361H8.28718V5.9494C8.28718 3.41353 9.89218 2.16602 12.1538 2.16602C13.2372 2.16602 14.1688 2.24685 14.4405 2.28268V4.93272H12.8713C11.6413 4.93272 11.3547 5.51856 11.3547 6.37608V8.40361H14.4213L13.808 11.4703H11.3547L11.4038 18.8329",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0a76a3eed71b76d1f7776f5c053fb5e5.svg";
export { ForwardRef as ReactComponent };